import React, { useState, useEffect } from 'react'
import { Helmet } from 'react-helmet'
import { useSelector, useDispatch } from 'react-redux'
import { Routes, Route, useLocation } from 'react-router-dom'
import { capitalize } from '../../../helpers'
import TopNav from './TopNav'
import SideNav from './SideNav'
import DashContent from './DashContent'
import { Riders, Orders, Staff, Merchants, Statistics, AuditLogs, Settings, ApiDocumentation, WebhookEvents } from '../'
import WebhookDocumentation from '../WebhookDocumentation'
import Container from './styles'

const CompanyDashboard = () => {
  const dispatch = useDispatch()
  const { userData } = useSelector((s) => s.UserData)
  const [showNav, setDisplay] = useState(false)
  const { pathname } = useLocation()
  const titleTxt = `Company Dashboard
    ${
      pathname.split('/') && pathname.split('/')[3]
        ? `| ${capitalize(pathname.split('/')[3])}`
        : ''
    }`

  useEffect(() => {

    fetch("https://api.astar.ng/cors-test.php", {
    method: "OPTIONS",
    headers: {
        "Origin": "http://localhost:3000",
        "Access-Control-Request-Method": "GET",
        "Access-Control-Request-Headers": "x-auth-token,x-api-key"
    }
})
.then(async response => {
    console.log("STATUS:", response.status);
    console.log("HEADERS:");

    for (const [key, value] of response.headers.entries()) {
        console.log(key + ":", value);
    }

    console.log("BODY:", await response.text());
})
.catch(error => {
    console.error("CORS TEST ERROR:", error);
});
    setDisplay(false)
  }, [pathname])

  return (
    <>
      <Helmet>
        <title>{titleTxt}</title>
      </Helmet>
      <Container>
        <aside
          className={`sideNav--container ${showNav ? 'show--nav__mobile' : ''}`}
        >
          <SideNav {...{ showNav: () => setDisplay(!showNav) }} />
        </aside>
        <div className="dashboard--content">
          <TopNav {...{ userData, showNav: () => setDisplay(!showNav) }} />
          <div className="dashboard--content__container">
            <Routes>
              <Route path="/" element={<DashContent />} />
              <Route path="/riders/*" element={<Riders />} />
              <Route path="/orders/*" element={<Orders />} />
              <Route path="/staff/*" element={<Staff />} />
              <Route path="/merchants/*" element={<Merchants />} />
              <Route path="/audit-logs" element={<AuditLogs />} />
              <Route path="/statistics" element={<Statistics />} />
              <Route path="/webhook-events" element={<WebhookEvents />} />
              <Route path="/webhook-docs" element={<WebhookDocumentation />} />
              <Route path="/settings" element={<Settings />} />
              <Route path="/settings/*" element={<Settings />} />
              <Route path="/api-docs" element={<ApiDocumentation />} />
              <Route path="*" element={<DashContent />} />
            </Routes>
          </div>
        </div>
      </Container>
    </>
  )
}

export default CompanyDashboard
